import { DomainEnum, FeatureIdEnum } from '../enums';

export const ROUTER_CONSTS = {

  routes: {
    login: 'login',
    logout: 'logout',
    home: 'home',
    [DomainEnum.SEARCH]: DomainEnum.SEARCH,
    [DomainEnum.BROWSE]: DomainEnum.BROWSE,
    analytics: 'analytics',
    overall: 'overall',
    queries: 'queries',
    insights: 'insights',
    now: 'now',
    origins: 'origins',
    keywords: 'keywords',
    equalize: {
      list: 'equalize',
      create: 'createEqualize',
      update: 'updateEqualize'
    },
    equalizeDashboard: {
      list: 'equalizeDashboard',
      create: 'createEqualizeDashboard',
      update: 'updateEqualizeDashboard'
    },
    synonyms: {
      list: 'synonyms',
      create: 'createSynonym',
      update: 'updateSynonym'
    },
    synonymsDashboard: {
      list: 'synonymsDashboard',
      create: 'createSynonymDashboard',
      update: 'updateSynonymDashboard'
    },
    blacklist: {
      list: 'blacklist',
      create: 'createBlacklist',
      update: 'updateBlacklist'
    },
    promotions: {
      list: 'promotions',
      create: 'createPromotion',
      update: 'updatePromotion'
    },
    redirections: {
      list: 'redirections',
      create: 'createRedirection',
      update: 'updateRedirection'
    },
    links: {
      list: 'links',
      create: 'createLink',
      update: 'updateLink'
    },
    boosts: {
      list: 'boosts',
      create: 'createBoost',
      update: 'updateBoost'
    },
    productsRanking: {
      list: 'productsRanking',
      create: 'createProductsRanking',
      update: 'updateProductsRanking'
    },
    attributesRanking: {
      list: 'attributesRanking',
      create: 'createAttributesRanking',
      update: 'updateAttributesRanking'
    },
    configurations: {
      [DomainEnum.SEARCH]: {
        list: 'searchConfigurations',
        create: 'createSearchConfiguration',
        update: 'updateSearchConfiguration'
      },
      [DomainEnum.BROWSE]: {
        attributes: 'browseConfigurations',
        attribute: 'browseConfigurationsAttribute',
        list: 'browseConfigurationsList',
        create: 'createBrowseConfiguration',
        update: 'updateBrowseConfiguration'
      }
    },
    relatedTags: {
      list: 'relatedTags',
      create: 'createRelatedTags',
      update: 'updateRelatedTags'
    },
    explain: 'explain',
    audit: 'audit',
    index: 'index',
    instances: {
      list: 'instances',
      create: {
        root: 'createInstance',
        [FeatureIdEnum.PERMISSIONS]: 'createInstancePermissions',
        [FeatureIdEnum.KPIS]: 'createInstanceKpis',
        [FeatureIdEnum.CATALOG]: 'createInstanceCatalog',
        [FeatureIdEnum.TOOLS]: 'createInstanceTools'
      },
      update: {
        root: 'updateInstance',
        [FeatureIdEnum.PERMISSIONS]: 'updateInstancePermissions',
        [FeatureIdEnum.KPIS]: 'updateInstanceKpis',
        [FeatureIdEnum.CATALOG]: 'updateInstanceCatalog',
        [FeatureIdEnum.TOOLS]: 'updateInstanceTools'
      }
    },
    users: {
      list: 'users',
      create: 'createUser',
      update: 'updateUser'
    },
    account: 'account',
    pageNotFound: 'pageNotFound'
  },
  params: {
    instanceId: 'instanceId',
    attribute: {
      name: 'attributeName',
      value: 'attributeValue'
    },
    id: 'id'
  },
  query: {
    redirect: 'redirect',
    filterPrefix: 'filter.',
    query: 'q',
    fullscreen: 'fullscreen'
  }

};
